/* NEXUS — script propio. Todo el JS de marca vive aquí. */
(function () {
  "use strict";

  /* Free shipping progress bar: a custom element so it re-animates every time
     Shopify's cart AJAX flow swaps in fresh HTML (add/remove/update line item),
     not just on the initial page load. */
  if (!window.customElements.get("nx-shipping-bar")) {
    window.customElements.define("nx-shipping-bar", class NxShippingBar extends HTMLElement {
      connectedCallback() {
        var fill = this.querySelector(".nx-shipping-bar__fill");
        if (!fill) return;
        var target = parseFloat(this.getAttribute("data-percent")) || 0;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          fill.style.width = target + "%";
          return;
        }
        fill.style.width = "0%";
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.style.width = target + "%";
          });
        });
      }
    });
  }

  function initReveal() {
    var items = document.querySelectorAll(".nx-reveal, .nx-reveal-scale");
    if (!items.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      items.forEach(function (el) { el.classList.add("nx-visible"); });
      return;
    }
    var groups = document.querySelectorAll("[data-nx-stagger]");
    groups.forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (child, i) {
        child.style.setProperty("--nx-i", i);
      });
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("nx-visible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    items.forEach(function (el) { obs.observe(el); });

    /* Red de seguridad: si por lo que sea el navegador nunca dispara el
       observador (pestaña en segundo plano, etc.), el contenido no debe
       quedar invisible para siempre. */
    setTimeout(function () {
      items.forEach(function (el) { el.classList.add("nx-visible"); });
    }, 2500);
  }

  function initCountUp() {
    var nums = document.querySelectorAll("[data-nx-countto]");
    if (!nums.length) return;
    function finalize(el) {
      var target = parseFloat(el.getAttribute("data-nx-countto")) || 0;
      var suffix = el.getAttribute("data-nx-suffix") || "";
      el.textContent = (target < 10 ? target.toFixed(1) : target) + suffix;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var target = parseFloat(el.getAttribute("data-nx-countto")) || 0;
        var suffix = el.getAttribute("data-nx-suffix") || "";
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target < 10 ? (target * eased).toFixed(1) : Math.round(target * eased);
          el.textContent = val + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { obs.observe(el); });
    setTimeout(function () { nums.forEach(finalize); }, 2500);
  }

  function initGallery() {
    document.querySelectorAll("[data-nx-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-nx-gallery-main]");
      var thumbs = gallery.querySelectorAll("[data-nx-gallery-thumb]");
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-full");
          var alt = thumb.getAttribute("data-alt") || "";
          main.querySelectorAll("img").forEach(function (img) {
            img.src = src; img.alt = alt;
          });
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  function initVariantPicker() {
    document.querySelectorAll("[data-nx-product-form]").forEach(function (root) {
      var dataEl = root.querySelector("[data-nx-variants]");
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInputs = root.querySelectorAll('input[name="id"]');
      var priceEl = root.querySelector("[data-nx-price]");
      var comparePriceEl = root.querySelector("[data-nx-compare-price]");
      var installmentNoteEl = root.querySelector("[data-nx-installment-note]");
      var submitBtn = root.querySelector("[data-nx-submit]");
      var submitLabel = submitBtn ? submitBtn.querySelector("[data-nx-submit-label]") : null;
      var optionInputs = root.querySelectorAll("[data-nx-option]");

      function money(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || "es-ES", {
          style: "currency",
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR"
        });
      }

      function currentOptions() {
        var vals = [];
        optionInputs.forEach(function (group) {
          var checked = group.querySelector("input:checked, select");
          if (checked) vals.push(checked.value || checked.options[checked.selectedIndex].value);
        });
        return vals;
      }

      function findVariant() {
        var sel = currentOptions();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === sel[i]; });
        });
      }

      function update(opts) {
        opts = opts || {};
        var v = findVariant();
        if (!v) return;
        idInputs.forEach(function (input) {
          input.value = v.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
        if (priceEl) priceEl.textContent = money(v.price);
        if (installmentNoteEl) installmentNoteEl.textContent = "4 interest-free payments of " + money(v.price / 4) + " each";
        if (comparePriceEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            comparePriceEl.textContent = money(v.compare_at_price);
            comparePriceEl.style.display = "";
          } else {
            comparePriceEl.style.display = "none";
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !v.available;
          if (submitLabel) submitLabel.textContent = v.available ? submitBtn.getAttribute("data-label-available") : submitBtn.getAttribute("data-label-sold-out");
        }
        // Skip the gallery image swap on the initial page-load sync: the server
        // already renders the gallery's actual first image/thumbnail as the
        // default, and jumping to the selected variant's own photo here would
        // override that with whichever image happens to be tied to variant 1
        // (e.g. "Black"), even when that isn't the first photo in the gallery.
        if (!opts.skipImage && v.image) {
          var gallery = root.closest("[data-nx-gallery]") || document.querySelector("[data-nx-gallery]");
          if (gallery) {
            var main = gallery.querySelector("[data-nx-gallery-main]");
            if (main) {
              main.querySelectorAll("img").forEach(function (img) {
                img.src = v.image; img.alt = v.alt || "";
              });
            }
            var thumbs = gallery.querySelectorAll("[data-nx-gallery-thumb]");
            var matched = null;
            thumbs.forEach(function (t) {
              t.classList.remove("is-active");
              if (v.media_id && t.getAttribute("data-media-id") === String(v.media_id)) matched = t;
            });
            if (matched) matched.classList.add("is-active");
          }
        }
      }

      optionInputs.forEach(function (group) {
        group.addEventListener("change", function () { update(); });
      });
      update({ skipImage: true });
    });
  }

  function initCardTilt() {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    document.querySelectorAll("[data-nx-tilt]").forEach(function (card) {
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = "perspective(800px) rotateX(" + (y * -4) + "deg) rotateY(" + (x * 4) + "deg) translateY(-4px)";
      });
      card.addEventListener("mouseleave", function () {
        card.style.transform = "";
      });
    });
  }

  function initFaqAccordion() {
    document.querySelectorAll("[data-nx-faq-item]").forEach(function (item) {
      var trigger = item.querySelector("[data-nx-faq-trigger]");
      if (!trigger) return;
      trigger.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        item.closest("[data-nx-faq]").querySelectorAll("[data-nx-faq-item]").forEach(function (i) {
          i.classList.remove("is-open");
        });
        if (!isOpen) item.classList.add("is-open");
      });
    });
  }

  function initTestimonialDrag() {
    document.querySelectorAll("[data-nx-drag]").forEach(function (track) {
      var isDown = false, startX, scrollLeft;
      track.addEventListener("mousedown", function (e) {
        isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
      });
      ["mouseleave", "mouseup"].forEach(function (evt) {
        track.addEventListener(evt, function () { isDown = false; });
      });
      track.addEventListener("mousemove", function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.4;
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initCountUp();
    initGallery();
    initVariantPicker();
    initCardTilt();
    initFaqAccordion();
    initTestimonialDrag();
  });
})();
